export default __webpack_public_path__ + "static/media/spoofwear.386c5e76.gif";